import React, { useEffect, useCallback, useState} from 'react';
import ipfs from 'decentralized/Ipfs.js';
import {addEffect} from 'scripting/commands/effects.js';
import {connect} from 'react-redux';
import {getEffectPresets} from 'decentralized/effects/EffectPresets.js';

const EffectPresets = ({effect, sequencerEngine, matchedPresets}) => { 
    const [presets, setPresets] = useState([]);

    useEffect(() => {
        if (matchedPresets.length > 0) {
            setPresets(matchedPresets);
        } else {
            getEffectPresets(effect).then(
                p => setPresets(p));
        }
    }, [setPresets, effect, matchedPresets]);

    const loadPreset = useCallback(async (e, preset) => {
        e.stopPropagation();
        let fx = addEffect(sequencerEngine, effect, undefined, undefined, true);
        let json = await ipfs.getJson(preset.effectHash);
        let trackNumber = sequencerEngine.cursor.track;
        await fx.fromJson(json, sequencerEngine.tracks, trackNumber, true, false);
        
        if (fx.track && fx.track.loadLostParameters) {
            fx.track.loadLostParameters();
        }
    }, [effect, sequencerEngine]);

    return (
        <div className="effect-presets">
          {presets.map(
              preset =>
                  <div
                    onClick={(e) => loadPreset(e, preset)}
                    className="preset-option">
                    {preset.title.trim()}
                  </div>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectPresets);
